<template>
  <div class="custom-main custom-theme">
    <a-row>
      <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
      <a-col :xs="8" :sm="8" :md="4" :lg="3" :xl="3" :xxl="3">
        <a-menu style="width: 256px">
          <a-menu-item key="params">
            <router-link :to="'/layout/system/config/params'">
              <a-icon type="bars" />
                系统参数设置
              </router-link>
          </a-menu-item>
          <a-menu-item key="bank">
            <router-link :to="'/layout/system/config/account'">
              <a-icon type="bank" />
              银行账户设置
            </router-link>
          </a-menu-item>
          <a-menu-item key="basic">
            <router-link :to="'/layout/system/config/basic'">
              <a-icon type="pay-circle" />
              药品加成比例设置
            </router-link>
          </a-menu-item>
        </a-menu>
      </a-col>
      <a-col :xs="14" :sm="14" :md="18" :lg="19" :xl="19" :xxl="19">
        <router-view/>
      </a-col>
      <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "Config"
}
</script>

<style scoped>

</style>